var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},_vm._l((_vm.tags),function(tag,i){return _c('Tag',{key:i},[_vm._v(_vm._s(tag))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }